import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import "../CustomerDetails/index.scss";
import Loader from "react-loader-spinner";
import {
  userChosenPropertyId,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenEmergencyQuestion,
  userChosenAdditionalDescription,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenUPRN,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  showFooter,
  saveEmailCopyRadioValue,
  saveAlternateEmailValue,
  isSendCopyDampMouldReport
} from "../../ducks/redux/actions/userChoices";
import * as EmailValidator from 'email-validator';
import {
  Container,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import Button from "../../storybook/Button";
import BackModal from "../Modal/BackModal";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import { CustomerName } from "../../models/Customer";
import * as api from "../../api";
import {
  RepairReporterId,
  ReportContactDetails,
} from "../../models/Repair/Repair";
import TextInputField from "../../storybook/TextInputField/TextInputField";
import PageHeader from "../../storybook/PageHeader/PageHeader";
import Dropdown from "../../storybook/Dropdown";
import HeaderJourney from "../../storybook/Header/HeaderJourney"
import Message from "../../storybook/Message";
import { Helper } from "../../utils/Helper/HelperUtil";
import { CasePriority, RepairPriorityCode } from "../../models/Repair/RepairPriority";

interface CustomerDetailsProps extends RouteComponentProps<any> {
  /* cId: any, 
    setErrorCheck: any */
}
const CustomerDetails: React.FC<CustomerDetailsProps> = (props) => {
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
    "Housing Health and Safety Rating System" = 14,
  }
  const { t } = useTranslation();
  const contactDetailsOptions = [
    { id: 'custDetails-op1', label: t("Customer_Option") },
    { id: 'custDetails-opt2', label: t("Friend_Option") },
    { id: 'custDetails-opt3', label: t("Other_Option") },
  ];
  const customerPhone = useSelector(
    (state: any) => state?.addresses?.customerPhoneNumber
  );
  const priority = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject[0]
        ?.priority
  );
 
  const isHazardRepair = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject?.[0]?.isHazard === true
  );
  const [inputState, setInputState] = useState<any>(t("Customer_Option"));
  const isHHSRSAssessmentCompleted = useSelector((state: any) => state?.hazard?.isHHSRSAssessmentCompleted === true);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState("");
  var errorArray: any[] = [];
  const [errorArrayState, seterrorArrayState] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [numberInput, setNumberInput] = useState("");
  const radioText = t("Provide_Number");
  const userchosenDMC = useSelector((state: any) => state.userChoicesReducer?.DMCChecksavedAnswer);
  const [radiovalue, setRadioValue] = useState(
    customerPhone !== null && customerPhone !== undefined && customerPhone !== ""
      ? customerPhone[0]?.number
        ? `${customerPhone[0].number}@0`
        : radioText
      : radioText
  );
  //const isinputdisabled = radiovalue != radioText;
  const [isinputdisabled, setIsInputDisabled] = useState<boolean>(true);

  const userChosenContactDetailsBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactDetails
  );
  const userChosenContactNameBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactName
  );
  const userChosenContactPhoneBackButton = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactPhone
  );
  const userChosenRelationSelect = useSelector(
    (state: any) => state.userChoicesReducer.userChosenRelationDetails
  );
  const userChosenPropertyType = useSelector(
    (state: any) => state.userChoicesReducer.userChosenPropertyType
  );
  const userChosenVulnerabilityQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVulnerabilityQuestion
  );
  const userChosenVulnerabilityAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVulnerabilityAdditionalInformation
  );
  const ValueCustomerPreferences = useSelector(
    (state: any) => state?.userChoicesReducer?.checkToggleValueCustomerPreferences
  );
  const HHSRSToggleForCustomerPreferences = useSelector(
    (state: any) => state?.userChoicesReducer?.checkHHRSToggleValueCustomerPreferences
  );
  const HHSRSRepairEnabledToggle = useSelector(
    (state: any) => state?.userChoicesReducer?.checkHHRSRepairEnabledToggleValue
  );
  const userChosenVandalismQuestion = useSelector(
    (state: any) => state.userChoicesReducer.userChosenVandalismQuestion
  );
  const userChosenVandalismAdditionalInformation = useSelector(
    (state: any) =>
      state.userChoicesReducer.userChosenVandalismAdditionalInformation
  );
  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );

  const covidConfigValue = useSelector(
    (state: any) => state?.addresses?.covidtoggleValue
  );
  const eligibilityResponseObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.eligibilityResponseObject
  );
  const vandalismConfigValue = useSelector(
    (state: any) => state?.addresses?.vandalismtoggleValue
  );
 
  const priorityCodeValue = useSelector(
    (state: any) => state.userChoicesReducer?.repairPriority
  );
  
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );

  const errorArrayEmailCopy: any[] = [];
  const [errorEmailCopyArrayState, seterrorEmailCopyArrayState] = useState<string[]>([]);
  const getEmailCopyValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenEmailCopyRadioValue
  );
  const chosenAlternateEmailValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenAlternateEmailValue
  );
  const dmcRiskRating = useSelector(
    (state: any) => state.userChoicesReducer?.dmcRiskRating
  );
  const [alternateEmailValue, setalternateEmailValue] = useState("");
  const [radioValueEmailCopy, setradioValueEmailCopy] = useState("")
  const [alternateEmail, setAlternateEmail] = useState<boolean>(false);
  const [showDMLPreferenceQuestion, setShowDMLPreferenceQuestion] = useState(false);
  const dmcInspectionSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
  );
  const ReportingComplianceEffectiveDate = useSelector(
    (state: any) => state?.userChoicesReducer?.ReportingComplianceEffectiveDateValue
  );
  const [ReportingComplianceEffectiveText, setReportingComplianceEffectiveText] = useState<boolean>(false);
 
   const shouldApplyCustomerPreferencesForHHSRS = (): boolean => {     
   return (
    HHSRSToggleForCustomerPreferences && HHSRSRepairEnabledToggle && isHHSRSAssessmentCompleted &&
    ((priorityCodeValue === RepairPriorityCode.AWAABSLAWEMERGENCY || priorityCodeValue === RepairPriorityCode.AWAABSLAWSIGNIFICANT || priorityCodeValue === RepairPriorityCode.AWAABSLAWLOW) )
   )
  }
  const shouldApplyCustomerPreferencesForDMC = (): boolean => {   
    return (
      ValueCustomerPreferences &&
      (dmcInspectionSorCodes?.includes(workOrderObject?.sorCode) || userchosenDMC === "Yes")
    );
  };

  const setRadioValueFromBackButtonSelection = () => {
    if (!userChosenContactDetailsBackButton) {
      return;
    }

    if (userChosenContactDetailsBackButton.includes("@")) {
      setRadioValue(userChosenContactDetailsBackButton);
      return;
    }

    setRadioValue(userChosenContactDetailsBackButton);
    const matchingPhoneIndex = customerPhone?.findIndex(
      (number: any) => number.number === userChosenContactDetailsBackButton
    );

    if (matchingPhoneIndex !== undefined && matchingPhoneIndex > -1) {
      setRadioValue(`${userChosenContactDetailsBackButton}@${matchingPhoneIndex}`);
    }
  };

  const initializeEmailCopyPreferences = () => {
    if (getEmailCopyValue !== "") {
      setradioValueEmailCopy(getEmailCopyValue);
      setAlternateEmail(getEmailCopyValue === t("DMC_option_alert_email"));
    }

    if (chosenAlternateEmailValue !== "") {
      setalternateEmailValue(chosenAlternateEmailValue);
    }
  };

  const initializeContactDetailsSelection = () => {
    if (userChosenContactDetailsBackButton === radioText) {
      setRadioValue(radioText);
      setUserInput(userChosenContactNameBackButton);
      setNumberInput(userChosenContactPhoneBackButton);
      const contactRelation = userChosenRelationSelect === "Friend or family"
        ? "Friend or Family"
        : userChosenRelationSelect || t("Customer_Option");
      setInputState(contactRelation);
      dispatch(userChosenRelationDetails(contactRelation));
      return;
    }

    if (!userChosenContactDetailsBackButton && !userChosenContactPhoneBackButton) {
      if (customerPhone?.length > 0 && customerPhone[0]?.number !== "") {
        dispatch(userChosenContactDetails(`${customerPhone[0]?.number}@0`));
        dispatch(userChosenRelationDetails(""));
      }
      return;
    }

    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
  };

  const shouldRestoreSelectionFromHistory = () => {
    return ["PUSH", "POP", "REPLACE"].includes(props.history.action);
  };  


  useEffect(() => {  
    window.scrollTo(0, 0);
    setShowDMLPreferenceQuestion(dmcRiskRating === CasePriority.Low);
    setReportingComplianceEffectiveText(
      new Date(ReportingComplianceEffectiveDate.toString()) <= new Date()
    );

    if (shouldRestoreSelectionFromHistory()) {
      setRadioValueFromBackButtonSelection();
    }

    initializeEmailCopyPreferences();
    initializeContactDetailsSelection();
    setIsInputDisabled(radiovalue !== radioText);
  
  }, [radiovalue, customerPhone]);

  const updateSelection = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.value !== radioText) {
      setInputState(t("Customer_Option"));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      setNumberInput("");
      setUserInput("");
      seterrorArrayState([]);
      errorArray = [];
      setIsInputDisabled(true);
    } else {
      dispatch(userChosenRelationDetails("Customer"));
      setIsInputDisabled(false);
    }
    setRadioValue(e.target.value);
    dispatch(userChosenContactDetails(e.target.value));
  };


  const inputChangeHandler = (event: any) => {
    const re = Helper.ValidationRegex.NumericOnly;
    // if value is not blank, then test the regex
    seterrorArrayState([]);
    errorArray = [];
    if (event.target.value === "" || re.test(event.target.value)) {
      //  @ts-ignore
      setNumberInput(event.target.value.toString().slice(0, 11));
      dispatch(userChosenContactPhone(event.target.value.toString().slice(0, 11)));
    }
  };

  const nameInputChangeHandler = (e: any) => {
    const re = Helper.ValidationRegex.AlphabetWithSpecialChars;
    // if value is not blank, then test the regex
    if (e.target.value === "" || re.test(e.target.value)) {
      setUserInput(e.target.value);
      dispatch(userChosenContactName(e.target.value));
    }
  };

  const submitForm = (): boolean => {
    seterrorArrayState([]);
    errorArray = [];

    const phoneEmpty = t("SSR014");
    const phoneInvalid = t("SSR002");
    const nameError = t("SSR058");
    const ukCountryCode = "0";

    if (radiovalue === radioText) {
      if (!numberInput) {
        errorArray.push(phoneEmpty);
      } else if (
        numberInput.slice(0, 1) !== ukCountryCode ||
        numberInput.length < 11
      ) {
        errorArray.push(phoneInvalid);
      }
      if (!userInput || userInput.length <= 0) {
        errorArray.push(nameError);
      }
      if (shouldApplyCustomerPreferencesForDMC() || shouldApplyCustomerPreferencesForHHSRS()) {
        emailvalidate()
      }
    }

    if (errorArray.length > 0) {
      seterrorArrayState([...errorArray]);
      return false;
    }
    if (!emailvalidate() && (shouldApplyCustomerPreferencesForDMC() || shouldApplyCustomerPreferencesForHHSRS())) {
      return false;
    }

    try {
      setIsLoading(true);
      dispatch(userChosenRelationDetails(inputState));
      workOrderObject.reporterContactDetails = new ReportContactDetails();
      if (radiovalue !== radioText) {
        const radioUpdatedValue = radiovalue.split("@");

        workOrderObject.reporterContactDetails.contactNumber = radioUpdatedValue[0];
      } else {
        workOrderObject.reporterContactDetails.contactNumber =
          numberInput.length > 0 ? numberInput : null;
        dispatch(userChosenRelationDetails(inputState));
        dispatch(userChosenContactPhone(numberInput));
        dispatch(userChosenContactName(userInput));
        dispatch(userChosenContactDetails(radioText));
      }

      const reporterFullName = customerDetails?.person?.name.title + " " + customerDetails?.person?.name.givenName + " " + customerDetails?.person?.name.surname;
      const contactPersonName = new CustomerName({
        title: null,
        givenName: radiovalue !== radioText ? reporterFullName.trim() : userInput?.trim(),
        surname: null,
      });
      workOrderObject.reporterContactDetails.name =
        contactPersonName;

      workOrderObject.reportedById =
        RepairReporterId[inputState as keyof typeof RepairReporterId];
      workOrderObject.reportedBy = inputState;

      // This will always be set as true in Self Serve channels, verified with ERGO, where 
      // 1. IF Customer contacts, the reporterToBeContacted = true
      // 2. IF someone else contacts and agrees to be contacted,
      //    THEN contact detail has to be submitted, the reporterToBeContacted = true
      // 3. IF someone else contacts and disagrees to be contacted,
      //    THEN contact detail is not submitted, the reporterToBeContacted = false

      workOrderObject.reporterContactDetails.reporterToBeContacted = true;
      if (shouldApplyCustomerPreferencesForDMC() || shouldApplyCustomerPreferencesForHHSRS()) {
        const digitaladdress = {
          address: alternateEmailValue ? alternateEmailValue : customerDetails?.addresses?.digitalAddresses[0]?.address,
          digitalAddressType: "email",
          isPreferred: true
        }
        const communicationPreferences = {
          preferenceType: '',
          addresses: { postalAddresses: [] as any[], digitalAddresses: [] as any[] }
        };
        if (getEmailCopyValue === t("DMC_option_email") || alternateEmailValue !== "") {
          communicationPreferences.preferenceType = "email";
          communicationPreferences.addresses.digitalAddresses?.push(digitaladdress);
          dispatch(isSendCopyDampMouldReport(true))
        }
        else {
          communicationPreferences.preferenceType = "postal";
        }

        if (!workOrderObject.assessmentInformation) {
          workOrderObject.assessmentInformation = {};
        }
        workOrderObject.assessmentInformation.communicationPreference = communicationPreferences;
       
      }
      userChosenVulnerabilityQuestion !== "" &&
        userChosenVulnerabilityQuestion !== null &&
        userChosenVulnerabilityQuestion !== "No"
        ? (workOrderObject.isVulnerable = true)
        : (workOrderObject.isVulnerable = false);
      userChosenVulnerabilityAdditionalInformation !== ""
        ? (workOrderObject.VulnerableResponseText = userChosenVulnerabilityAdditionalInformation)
        : (workOrderObject.VulnerableResponseText = null);

      if (userChosenVandalismQuestion === "Yes") {
        workOrderObject.crimeReferenceNumber = userChosenVandalismAdditionalInformation;
        workOrderObject.repairCause = "Vandalism or Damage";
        workOrderObject.repairCauseId =
          RepairCauseId[
          workOrderObject.repairCause as keyof typeof RepairCauseId
          ];
      }
      
     if(isHHSRSAssessmentCompleted){
      workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
      workOrderObject.repairCause =
      Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];  
    }
       else {
        workOrderObject.crimeReferenceNumber = "";
        workOrderObject.repairCause = "General Wear and Tear";
        workOrderObject.repairCauseId =
          RepairCauseId[workOrderObject.repairCause as keyof typeof RepairCauseId];
      }      
       workOrderObject.priority = priorityCodeValue;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );
      dispatch(workOrderRepairObject(workOrderObject));
      return true;
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      dispatch(saveEmailCopyRadioValue(""));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };
  const emailChangeHandler = (e: any) => {
    setalternateEmailValue(e.target.value);
    if (e.target.value === "" || isValidEmail(e.target.value)) {
      seterrorEmailCopyArrayState([])
    }
  }

  const isValidEmail = (email: any) => {
    return EmailValidator.validate(email);
  }

  const getDMCPreferencePageHeader = () => {
    if (showDMLPreferenceQuestion) {
      return <PageHeader>{t("DMC_Preference_Question_DML")}</PageHeader>;
    } else if (ReportingComplianceEffectiveText) {
      return <PageHeader>{t("DMC_Preference_Question")}</PageHeader>;
    } else {
      return (
        <PageHeader>
          {t("From_DMC")} {new Date(ReportingComplianceEffectiveDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}, {t("DMC_Preference_Question_Complaince")}
        </PageHeader>
      );
    }
  }

  const getHHSRSPreferenceHeaderText = () => {
    if(priorityCodeValue === RepairPriorityCode.AWAABSLAWLOW)
     return <PageHeader>{t("CPR087_HHRS_PreferencePage_Title")}</PageHeader>;
    else if(priorityCodeValue === RepairPriorityCode.AWAABSLAWEMERGENCY || priorityCodeValue === RepairPriorityCode.AWAABSLAWSIGNIFICANT){
      return <PageHeader>{t("CPR086_HHRS_PreferencePage_Title")}</PageHeader>;
    }
  }

  const emailvalidate = () => {
    const emailSelectionMessageKey = shouldApplyCustomerPreferencesForHHSRS()
      ? "HHSRS_Warning_Message"
      : "DMC_email_report_copy_email_selection";

    if (getEmailCopyValue === "" || !getEmailCopyValue) {
      errorArrayEmailCopy.push(t(emailSelectionMessageKey));
      seterrorEmailCopyArrayState(errorArrayEmailCopy);
      return false;
    }
    else if (alternateEmailValue === "" && getEmailCopyValue === t("DMC_option_alert_email")) {
      errorArrayEmailCopy.push(t("DMC_email_report_copy_email_error"));
      seterrorEmailCopyArrayState(errorArrayEmailCopy);
      return false;
    }
    else if (!isValidEmail(alternateEmailValue) && getEmailCopyValue === t("DMC_option_alert_email")) {
      errorArrayEmailCopy.push(t("DMC_email_report_copy_error"));
      seterrorEmailCopyArrayState(errorArrayEmailCopy);
      return false;
    }
    else {
      seterrorEmailCopyArrayState([])
      dispatch(saveAlternateEmailValue(alternateEmailValue))
      return true;
    }
  }
  const emailSelectionRadioChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setradioValueEmailCopy(e.target.value);
    seterrorEmailCopyArrayState([])
    dispatch(saveEmailCopyRadioValue(e.target.value));
    setalternateEmailValue("");
    dispatch(saveAlternateEmailValue(""))
    if (e.target.value === t("DMC_option_alert_email")) {
      setAlternateEmail(true)
    }
    else {
      setAlternateEmail(false)
    }
  }
  const saveDraftAndExit = () => {
    seterrorArrayState([]);
    const isValid = submitForm();
    if (isValid) {
      setCloseAfterSaving(true);
      props.history.replace("/customer360View");
    }
  };

  const callPageHandler = () => {
    seterrorArrayState([]);
    const isValid = submitForm();
    if (isValid) {
      props.history.push("/confirmationdetails");
    }
  };

  const backButtonHandler = () => {
    if (HHSRSRepairEnabledToggle && isHazardRepair) {
      if (userChosenPropertyType === "Property" && covidConfigValue !== "false") {
        props.history.replace("/covidquestion");
      } else if (
        userChosenPropertyType !== "Property" &&
        eligibilityResponseObject?.statuses.isInDefects === true &&
        vandalismConfigValue === true
      ) {
        props.history.replace("/vandalismquestion");
      } else {
        props.history.push("/uploadmedia");
      }
      return;
    }

    if (userChosenPropertyType !== "Property") {
      if (priority !== "Emergency") {
        props.history.replace("/vulnerabilityquestion");
      } else {
        if (
          eligibilityResponseObject?.statuses.isInDefects === true &&
          vandalismConfigValue === true
        ) {
          props.history.replace("/vandalismquestion");
        } else {
          props.history.push("/uploadmedia");
        }
      }
    } else if (covidConfigValue === "false") {
      if (priority !== "Emergency") {
        props.history.replace("/vulnerabilityquestion");
      } else {
        if (
          eligibilityResponseObject?.statuses.isInDefects === true &&
          vandalismConfigValue === true
        ) {
          props.history.replace("/vandalismquestion");
        } else {
          props.history.push("/uploadmedia");
        }
      }
    } else {
      props.history.replace("/covidquestion");
    }
  };

  const exitButtonHandler = () => {
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenSOR(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(saveAlternateEmailValue(""))
    dispatch(saveEmailCopyRadioValue(""));
    props.history.push("/customer360View");
  };

  const handleChange = (e: { target: { value: any } }) => {
    setInputState(e.target.value);
    dispatch(userChosenRelationDetails(e.target.value));
  };


  let errorfieldsArray: any[] = [];
  let errorEmailCopyfieldsArray: any[] = [];
  errorArrayState?.forEach((err: any) => {
    errorfieldsArray.push(
      <Message className="warning-msg">
        {err}
      </Message>
    );
  });
  errorEmailCopyArrayState?.forEach((err: any) => {
    errorEmailCopyfieldsArray.push(
      <Message className="warning-msg">
        {err}
      </Message>
    );
  });

  return (
    <>
      <HeaderJourney ></HeaderJourney>
      <Container id="custDetails-container" className="padding-repair" role="main">

        <div id="custDetails-main-div">
          <PageHeader>
            {t("Customer_Details")}
          </PageHeader>
          {errorfieldsArray.length > 0 && (
            <div
              id="custDetails-div5"
              role="alert"
              placeholder="alert"
              className="detail-msg">
              {errorfieldsArray}
            </div>
          )}
          {isLoading ? (
            <Loader
              type="ThreeDots"
              color="#00BFFF"
              height={50}
              width={50}
              timeout={5000}
            />
          ) : (
            <>
              <div
                className="pt-44 phoneNumber"
                id="options"
                data-hj-suppress="">
                <RadioGroup
                  id="custDetails-radiogroup"

                  onChange={updateSelection}
                  value={radiovalue}
                >
                  {customerPhone.map((number: any, index: number) => {
                    return (
                      number.number && (
                        <FormControlLabel
                          id="custDetails-label1"
                          data-testid={"checkboxPhoneNumber" + index}
                          key={"customerPhoneNumber_" + index}
                          control={
                            <Radio
                              id={"custDetails-radio1" + index}
                              key="checkboxPhoneNumber"
                              name="checkboxPhoneNumber"
                              data-testid="checkboxPhoneNumber"
                            />
                          }
                          label={number.number}
                          value={`${number.number}@${index}`}
                        />
                      )
                    );
                  })}
                  <FormControlLabel
                    id="custDetails-label2"
                    control={
                      <Radio
                        id="custDetails-radio2"
                        key="phoneNumberforRepair"
                        name="phoneNumberforRepair"
                        data-testid="phoneNumberforRepair"
                      />
                    }
                    label={radioText}
                    value={radioText}
                  />{" "}
                </RadioGroup>
              </div>

              <div id="custDetails-div1" className="parent-div">
                <div
                  id="custDetails-div2"
                  className="pt-2 pt-lg-0"
                >
                  <h6 className="pb-12">Phone number</h6>
                  <TextInputField
                    id="custDetails-text1"
                    dataTestId="inputPhoneNumber"
                    ariaLabel="phone number"
                    type="text"
                    disabled={isinputdisabled}
                    value={numberInput}
                    placeholder="Please enter your phone number"
                    onChange={(e) => inputChangeHandler(e)}
                  >
                  </TextInputField>
                </div>

                <div
                  id="custDetails-div3"
                  className="pt-24"
                >
                  <h6 className="pb-12">Name</h6>
                  <TextInputField
                    id="custDetails-text3"
                    dataTestId="customerName"
                    ariaLabel="customer name"
                    type="text"
                    disabled={isinputdisabled}
                    value={userInput}
                    placeholder="Name"
                    onChange={nameInputChangeHandler}
                  >
                  </TextInputField>

                </div>

                <div
                  id="custDetails-div4"
                  className="pt-24"
                >
                  <h6 className="pb-12">{t("Repair_Contact_Details_Selection_Query")}</h6>
                  <Dropdown
                    options={contactDetailsOptions}
                    selectedOption={userChosenRelationSelect ?? inputState}
                    disabled={isinputdisabled}
                    handleChange={handleChange}
                    dataTestId="inputState"
                  >
                  </Dropdown>


                </div>
              </div>
            </>
          )}

        </div>
        {(shouldApplyCustomerPreferencesForHHSRS() || shouldApplyCustomerPreferencesForDMC()) && <div id="custDetails-main-div">
          {shouldApplyCustomerPreferencesForHHSRS() ? getHHSRSPreferenceHeaderText() : getDMCPreferencePageHeader()}

          {(shouldApplyCustomerPreferencesForDMC() || shouldApplyCustomerPreferencesForHHSRS()) && (
            <>
            {errorEmailCopyfieldsArray.length > 0 && (
              <div
                id="custDetails-div5"
                role="alert"
                placeholder="alert"
                className="detail-msg">
                {errorEmailCopyfieldsArray}
              </div>
            )}
            {isLoading ? (
              <Loader
                type="ThreeDots"
                color="#00BFFF"
                height={50}
                width={50}
                timeout={5000}
              />
            ) : (
              <div
                className="pt-44 phoneNumber"
                id="options"
                data-hj-suppress="">
                <RadioGroup
                  id="custDetails-radiogroup"
                  onChange={emailSelectionRadioChange}
                  value={radioValueEmailCopy}
                >
                  {[
                    {
                      id: "custDetails-radio3",
                      label: `${t("DMC_option_email")} ${customerDetails?.addresses?.digitalAddresses?.[0]?.address}`,
                      value: t("DMC_option_email"),
                      condition: customerDetails?.addresses?.digitalAddresses?.[0]?.address,
                    },
                    {
                      id: "custDetails-radio4",
                      label: t("DMC_option_alert_email"),
                      value: t("DMC_option_alert_email"),
                      condition: true,
                    },
                    {
                      id: "custDetails-radio5",
                      label: shouldApplyCustomerPreferencesForHHSRS() ? t("HHSRS_Preference_DoNotHaveEmail") : t("DMC_option_report_copy"),
                      value: shouldApplyCustomerPreferencesForHHSRS() ? t("HHSRS_Preference_DoNotHaveEmail") : t("DMC_option_report_copy"),
                      condition: true,
                    },
                  ].map(
                    (option, index) =>
                      option.condition && (
                        <fieldset key={index}>
                          <legend>
                            <FormControlLabel
                              id={`custDetails-label${index + 3}`}
                              className="cust-rad global-txt"
                              control={
                                <Radio
                                  id={option.id}
                                  name="emailOptions"
                                  data-testid={`emailOption${index}`}
                                />
                              }
                              label={option.label}
                              value={option.value}
                            />
                          </legend>
                          {alternateEmail && radioValueEmailCopy === t("DMC_option_alert_email") && option.value === t("DMC_option_alert_email") && (
                            <div id="custDetails-div1" className="preference-div">
                              <div id="custDetails-div2" className="pt-2 pt-lg-0 mb-2">
                                <h6 className="pb-12">Email</h6>
                                <TextInputField
                                  id="custDetails-text1"
                                  dataTestId="inputPhoneNumber"
                                  ariaLabel="phone number"
                                  type="email"
                                  disabled={false}
                                  value={alternateEmailValue}
                                  placeholder={t("alternate_email")}
                                  onChange={emailChangeHandler}
                                />
                              </div>
                            </div>
                          )}
                        </fieldset>
                      )
                  )}
                </RadioGroup>
              </div>
            )}
            </>
          )}
        </div>
        }
      </Container>
      <div className="col-md-12 marginTop-auto">
        <div className="row m-0 footer-actionbtn">
          <div className="col btn-top padding-repair mb-0">

            <BackModal id="custDetails-backmodal" back={backButtonHandler} />

            <ExitModalAndSave
              id="custDetails-exitmodal"
              exit={exitButtonHandler}
              saveDraftAndExit={saveDraftAndExit}
              closeAfterSaving={closeAfterSaving}
            />
          </div>
          <div className="col text-end pt-24 padding-repair">
            <Button
              id="btn_custmerDetails"
              onClick={callPageHandler}
              className="primary-btn"
            >
            { t("continuen_button")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerDetails;